// Main JS file

// DOM ready
$(function () {

    // Object-fit polyfill
    objectFitImages();

    var $body = $('body'),
        $navToggle = $('.nav-toggle'),
        navOpenClass = 'nav-open',
        $searchToggle = $('.search-toggle'),
        $searchInput = $('.header__search .search__input'),
        searchOpenClass = 'search-open',
        searchToggleActiveClass = 'active'
    ;

    // Nav toggle
    function toggleNav(visible) {
        $body.toggleClass(navOpenClass, visible);
        if (visible) {
            toggleSearch(false);
        }
    }
    $navToggle.on('click', function(e) {
        toggleNav(!$body.hasClass(navOpenClass));
    });

    // Search toggle
    function toggleSearch(visible) {
        if (visible) {
            // Open search
            $body.addClass(searchOpenClass);
            setTimeout(function() {
                $searchInput.focus();
            }, 300);
            $searchToggle
                .parent('li')
                .addClass(searchToggleActiveClass);
            toggleNav(false);
        } else {
            // Close search
            $body.removeClass(searchOpenClass);
            $searchInput.blur();
            $searchToggle
                .parent('li')
                .removeClass(searchToggleActiveClass);
        }
    }
    $searchToggle.on('click', function(e) {
        toggleSearch(!$body.hasClass(searchOpenClass));
    });

    // Global Esc press
    $(document).on('keyup', function(e) {
        if (e.keyCode === 27) { // Esc
            toggleSearch(false);
            toggleNav(false);
        }
    });

    // Global click outside menu/search
    $(document).on('click touchend', function(e) {
        // Nav
        if (!$(e.target).closest('.header__user-nav').length) {
            if (!$(e.target).closest('.header__nav').length) {
                toggleNav(false);
            }
            if (!$(e.target).closest('.header__search').length) {
                toggleSearch(false);
            }
        }
    });

    // Highlight show on-air
    (function() {
        var $trigger = $('[data-highlight-target]'),
            hoverClass = 'hover';

        function getTarget($trigger) {
            return $('[data-highlight-show="' + $trigger.data('highlight-target') + '"]');
        }

        $trigger.hover(
            function() {
                var $target = getTarget($(this));
                $target.addClass(hoverClass);
            },
            function() {
                var $target = getTarget($(this));
                $target.removeClass(hoverClass);
            });
    })();

    // Toggle more news
    (function() {
        var $toggle = $('[data-toggle="more-news"]');

        $toggle.on('click', function(e) {
            e.preventDefault();

            var $target = $('[data-toggle-id="' + this.dataset.toggle + '"]');
            $target.removeAttr('class');
            $toggle.parent('p').remove();
        });
    })();

    // Program channel switch & scroll to hash
    (function() {
        var $channelSwitch = $('.channel-switch');

        if ($channelSwitch.length) {
            var hash = location.hash,
                $toggle = $channelSwitch.find('[data-toggle-channel]'),
                $programContainer = $('[data-show-channel]'),
                toggleItemSelector = '.channel-switch__item',
                toggleActiveClass = 'channel-switch__item--active',
                showSelector = '.show',
                $activeShow = $(showSelector + hash);

            if (hash && $activeShow.length) {
                $('html, body').animate({
                    scrollTop: $activeShow.offset().top - 150 // header & channel switch
                }, 500);
            }

            $toggle.on('click', function(e) {
                var channel = this.dataset.toggleChannel,
                    url = '//' + location.hostname + location.pathname + '?kanal=' + channel + '#'; // clear hash
                $programContainer[0].dataset.showChannel = channel;

                window.history.replaceState({}, '', url);

                $(this)
                    .parent(toggleItemSelector)
                    .addClass(toggleActiveClass)
                    .siblings()
                    .removeClass(toggleActiveClass);
            });
        }
    })();

    // Program show detail (remodal)
    (function() {
        if ($('.program').length) {
            var $modal = $('[data-remodal-type="show-detail"]'),
                $modalContent = $modal.find('.remodal__content'),
                $openedShowDetail = $('[data-target="remodal"][data-hash="' + location.hash.substring(1) + '"]'),
                remodal = $modal.remodal({
                    hashTracking: false
                });

            if ($openedShowDetail.length) {
                openModal($openedShowDetail[0]);
            }

            $(document).on('closed', '.remodal', function(e) {
                $modalContent.html('');
            });

            $('.program [data-target="remodal"]').on('click', function(e) {
                e.preventDefault();
                openModal(this);
            });

            function openModal(trigger) {
                var url = trigger.href,
                    hash = trigger.dataset.hash;

                $modal.attr('data-remodal-id', hash);
                $modalContent.load(url, function() {
                    remodal.open();
                });
            }

            $(window).on('popstate', function () {
                remodal.close();
            });
        }
    })();

    // Date picker dropdown
    (function() {
        var $datePicker = $('.date-picker'),
            $toggle = $('.date-picker__selected'),
            openClass = 'date-picker--open';

        if ($datePicker.length) {
            $toggle.on('click', function(e) {
                $datePicker.toggleClass(openClass);
            });

            $(document).on('click touchend', function(e) {
                // Date picker
                if (!$(e.target).closest('.date-picker__body').length) {
                    $datePicker.toggleClass(openClass, false);
                }
            });
        }
    })();

    // Tabs
    (function() {
        var $tabs = $('.tabs'),
            $tabLinks = $('.tabs__tab-list a'),
            tabPanelClass = 'tabs__panel',
            $tabPanels = $('.' + tabPanelClass),
            tabLinkActiveClass = 'active';

        if ($tabs.length) {
            $tabLinks.on('click', function (e) {
                e.preventDefault();
                updateTabs(this.hash);
            });

            $(window).on('hashchange', function () {
                updateTabs(location.hash);
            });

            initTabs();

            function updateTabs(target) {
                var targets = [''];
                $tabLinks.each(function () {
                    targets.push(this.hash);
                });

                if (targets.indexOf(target) > -1) {
                    if (target !== location.hash) {
                        history.replaceState({}, '', target);
                    }

                    if (target === '') {
                        target = $tabLinks[0].hash;
                    }

                    $tabLinks
                        .removeClass(tabLinkActiveClass)
                        .filter('[href="' + target + '"]')
                        .addClass(tabLinkActiveClass);

                    $tabPanels
                        .hide()
                        .filter(target)
                        .show();
                }
            }

            function initTabs() {
                if (!$('.' + tabPanelClass + '[id="' + location.hash.substr(1) + '"]').length) {
                    $($tabLinks[0]).addClass(tabLinkActiveClass);
                    $tabPanels.filter($tabLinks[0].hash).show();
                } else {
                    updateTabs(location.hash);
                }
            }
        }
    })();

    // Sticky article aside
    (function() {
        stickyAside();

        $(window).on('resize', function(e) {
            stickyAside();
        });

        function stickyAside() {
            var $stickyContainer = $('.article__aside-inner');

            $stickyContainer.stickySidebar({
                topSpacing: $('.header').height() + 15,
                // bottomSpacing: 0,
                containerSelector: '.article__wrapper',
                // innerWrapperSelector: '.article__aside-inner',
                // resizeSensor: true,
                // stickyClass: 'is-affixed',
                minWidth: 900
            });
        }
    })();

    // Scroll to anchor
    (function() {
        if ($(location.hash).length) {
            var channelSwitchHeight = (($('.channel-switch').length && window.matchMedia('(max-width: 1199px)').matches ) ? 100 : 15);

            $('html, body').animate({
                scrollTop: $(location.hash).offset().top - $('.header').outerHeight() - channelSwitchHeight // header + 15px
            }, 500);
        }
    })();

});
